import axios from 'axios'
import router from "@/router";

const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL + '/api',   // 添加 /api 前缀
    timeout: 30000
});

request.interceptors.request.use(config => {
    // FormData（文件上传）让浏览器自动设 multipart/form-data; boundary=，强制 JSON 会破坏上传
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
    if (user.token) {
        config.headers['token'] = user.token;
        config.headers['Authorization'] = user.token;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

request.interceptors.response.use(
    response => {
        let res = response.data;
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res;
        }
        if (res.code === '401') {
            router.push('/login');
        }
        return res;
    },
    error => {
        console.error('请求错误：', error);
        // JwtInterceptor.sendError 鉴权失败时返回 HTTP 401 + body {code:'401',msg:'...'}。
        // axios 把 4xx 当 error，上面 success 分支里 res.code==='401' 的跳转永远不会触发，
        // 导致 token 过期时每个页面只弹“加载失败”而不踢回登录页。这里统一兜底：
        // 清掉失效 token、跳登录页，并把后端的真实原因透传给页面（弹“Token已过期”而非“加载失败”）。
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('xm-user');
            router.push('/login');
            if (error.response.data) {
                return Promise.resolve(error.response.data);
            }
        }
        return Promise.reject(error);
    }
);

export default request;